import React, { useRef } from 'react';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { tabStyles as styles } from './tabs.tailwind';
import Tab from './Tab';

// Tabs Section
const TabsSection = ({ activeTab, setActiveTab, tabsData }) => {
  const buttonContainerRef = useRef(null);
  // const [showLeftIcon, setShowLeftIcon] = useState(false);
  // const [showRightIcon, setShowRightIcon] = useState(false);

  // Handle scrolling
  // const handleScroll = () => {
    // const container = buttonContainerRef.current;
    // if (container) {
    //   setShowLeftIcon(container.scrollLeft > 0);
    //   setShowRightIcon(container.scrollWidth > container.clientWidth + container.scrollLeft);
    // }
  // };

  // handle scroll-left
  // const scrollLeft = () => {
  //   buttonContainerRef.current?.scrollBy({ left: -150, behavior: 'smooth' });
  // };

  // handle scroll-right
  // const scrollRight = () => {
  //   buttonContainerRef.current?.scrollBy({ left: 150, behavior: 'smooth' });
  // };

  // useEffect(() => {
    // const container = buttonContainerRef.current;    
    /**
     * Checks the scroll position of the container and updates the visibility of scroll icons.
     * If the content is scrollable, the right scroll icon is shown.
     * If the content has been scrolled from the left, the left scroll icon is shown.
     */
    // const checkScrollIcons = () => {
    //   if (container) {
    //     const isScrollable = container.scrollWidth > container.clientWidth;
    //     setShowRightIcon(isScrollable);
    //     setShowLeftIcon(container.scrollLeft > 0);
    //   }
    // };

    // checkScrollIcons();
    // container?.addEventListener('scroll', handleScroll);
    // window.addEventListener('resize', checkScrollIcons);

    // return () => {
    //   container?.removeEventListener('scroll', handleScroll);
    //   window.removeEventListener('resize', checkScrollIcons);
    // };
  // }, []);

  return (
    <div className={styles.buttonContainer} ref={buttonContainerRef} style={{ scrollbarWidth: 'none' }}>
      {/* show Left Icon */}
      {/* {showLeftIcon && (
        <button className={styles.leftIcon} onClick={scrollLeft}>
          <ChevronLeftIcon fontSize="large" />
        </button>
      )} */}

      {/* Tabs */}
      {tabsData.map((tab) => (
        <Tab
          key={tab?.id}
          tab={tab}
          isActive={tab?.tabName === activeTab}
          onClick={() => {
            setActiveTab(tab?.tabName)
          }}
        />
      ))}

      {/* show Right Icon */}
      {/* {showRightIcon && (
        <button className={styles.rightIcon} onClick={scrollRight}>
          <ChevronRightIcon fontSize="large" />
        </button>
      )} */}
    </div>
  );
};

export default TabsSection;
